/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S4_HeadingInputs */

const tr_hakkimizda_s4_heading = /** @type {(inputs: Hakkimizda_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüzel Yapı`)
};

const en_hakkimizda_s4_heading = /** @type {(inputs: Hakkimizda_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Structure`)
};

const de_hakkimizda_s4_heading = /** @type {(inputs: Hakkimizda_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtliche Struktur`)
};

const ru_hakkimizda_s4_heading = /** @type {(inputs: Hakkimizda_S4_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юридическая структура`)
};

/**
* | output |
* | --- |
* | "Legal Structure" |
*
* @param {Hakkimizda_S4_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s4_heading = /** @type {((inputs?: Hakkimizda_S4_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S4_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s4_heading(inputs)
	if (locale === "de") return de_hakkimizda_s4_heading(inputs)
	if (locale === "ru") return ru_hakkimizda_s4_heading(inputs)
	return tr_hakkimizda_s4_heading(inputs)
});